import Cookies from 'js-cookie';

const firstLandedGIKPageKey = 'firstLandedGIKPage';

export const markFirstLandedGIKPage = (pageRouteId: string) => {
  if (!Cookies.get(firstLandedGIKPageKey)) {
    Cookies.set(firstLandedGIKPageKey, pageRouteId);
  }
};
